class CartUpdateQuantity extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.minQty = parseInt(this.dataset.minQty) || 1;
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll(".btn-quantity").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);

		this.input.addEventListener("change", this.onInputChange.bind(this));
	}

	onButtonClick(event) {
		event.preventDefault();
		const $target = event.target;
		const el_input = $target.parentElement.querySelector(".quantity");
		const value = Number(el_input.value);
		let newVal;

		if ($target.matches(".plus")) {
			newVal = value + 1;
		} else if ($target.matches(".minus")) {
			newVal = value - 1;
		} else {
			newVal = value;
		}

		// Enforce minimum quantity
		if (newVal < this.minQty) {
			newVal = this.minQty;
			this.showMinQuantityWarning();
		}

		el_input.value = newVal;
		this.input.dispatchEvent(this.changeEvent);
	}

	onInputChange(event) {
		const value = Number(this.input.value);

		if (value < this.minQty) {
			this.input.value = this.minQty;
			this.showMinQuantityWarning();
		}
	}

	showMinQuantityWarning() {
		const message = `The minimum order quantity for this product is ${this.minQty}`;
		if (typeof halo !== "undefined" && typeof halo.showWarning === "function") {
			halo.showWarning(message, 3000);
		} else {
			alert(message);
		}
	}
}

customElements.define("cart-update-quantity", CartUpdateQuantity);
